import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import { push } from 'react-router-redux';
import { UserDetail, STORE_USER_PROFILE } from 'src/reducers/user';
import { STORE_FILES_2, STORE_PROGRESS, STORE_SENDING_INPROGRESS } from 'src/reducers/fileUpload';
import {
  STORE_ERROR_BAR,
  STORE_SUCCESS_BAR,
  STORE_ERROR_MESSAGE,
  STORE_SUCCESS_MESSAGE,
  STORE_SUCCESS_FILES_UPLOADED,
  STORE_ERROR_FILES_UPLOADED,
  STORE_SUCCESS_FILES_UPLOADED_MSG,
  STORE_ERROR_FILES_UPLOADED_MSG
} from 'src/reducers/errors';
import {
  STORE_PROGRESS_DOWNLOADING,
  RowDataCompleted,
  STORE_COMPLETEORDERDATA_DATE,
  STORE_COMPLETEORDERDATA,
  RowDataRawOrder,
  STORE_ORDERRAWDATA,
  STORE_ORDRAW_ENDDATE,
  STORE_ORDRAW_STARTDATE,
  STORE_ORDERRAWDATA_EXPORT,
  STORE_COMPLETEORDERDATA_EXPORT,
  STORE_MANUFACTCOMPLETEORDERDATA
} from 'src/reducers/completeorderfile';
import { STORE_PROGRESS_ISWAITING, STORE_RETURN_TRANSACTION_ID, STORE_RETURN_TRANSACTION_STATUS, STORE_RETURN_TRANSACTION_STATUS_DESC, STORE_P_STARTDATE, STORE_P_ENDDATE, STORE_PAYMENT_DATA } from 'src/reducers/payment';
import {
  RowDataManufactur,
  STORE_M_FILTERED_DATA,
  STORE_M_FILTERLESS_DATA,
  STORE_UNDERDESIGNDATA,
  STORE_DESIGNREADYDATA,
  STORE_MHOLDORDERDATA,
  STORE_MNEWORDERDATA,
  STORE_MINPRODUCTIONORDERDATA,
  STORE_M_PREVIEWORDER_DATA,
  STORE_M_FILTER_DATA_EXPORT
} from 'src/reducers/manufactur';
import { RowDataLive, STORE_NEWORDERDATA, STORE_LIVEORDERDATA, STORE_LIVEORDERDATA_ONHOLD, STORE_LIVEORDERDATA_RETURNED, RowDataCancel, STORE_CANCELORDERDATA } from 'src/reducers/liveorderfile';
import {
  STORE_USERPROFILEDATA,
  STORE_CUSTOMERNAME_PROFILE,
  STORE_CUSTOMEREMAIL_PROFILE,
  STORE_CUSTOMERPHONENUMBER_PROFILE,
  STORE_CUSTOMERADDRESSONE_PROFILE,
  STORE_CUSTOMERADDRESSTWO_PROFILE,
  STORE_CUSTOMERCOUNTRY_PROFILE,
  STORE_CUSTOMERSTATE_PROFILE,
  STORE_CUSTOMERPRODUCT_PROFILE,
  STORE_CUSTOMERSCANNER_PROFILE,
  STORE_CUSTOMERCONTACTNAME_PROFILE,
  STORE_CUSTOMERCONTACTNUMBER_PROFILE,
  STORE_CUSTOMERCOMMENT_PROFILE,
  STORE_CUSTOMEROCCLUSION,
  STORE_CUSTOMERDESIGNTYPE,
  STORE_CUSTOMERPONTICDESIGN,
  STORE_CUSTOMERCONTACT,
  STORE_CUSTOMERMODELTYPE,
  STORE_CUSTOMERNOTE,
  STORE_CUSTOMERDSOFT_PROFILE,
  STORE_CUSTOMERCUSTDEST_PROFILE,
  STORE_CUSTOMERCUSTTAT_PROFILE
} from 'src/reducers/userProfile';
import { STORE_DASHBOARD_LIVECOUNT, STORE_DASHBOARD_COMPLETEDORDER, STORE_DASHBOARD_ONHOLD, STORE_DASHBOARD_RETURNED, DataItem, STORE_CHART } from 'src/reducers/dashboard';
import { SearchValue, STORE_LOADER, STORE_NOTIFICATIONS_COUNT, STORE_SEARCHNAME, STORE_SEARCHTRUE, STORE_SEARCHTYPE, STORE_SEARCHVALUE, STORE_VERTICAL_VIEW_SCREEN } from 'src/reducers/landingPage';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { STORE_MYINVOICES_DATA, STORE_PAIDINVOICE_DATA } from 'src/reducers/paidinvoice';
import { STORE_M_LAB_DATA, STORE_M_CHOSEN_LAB_DATA, STORE_M_BRANCH_DATA, STORE_M_FILES_UPLOAD, STORE_M_SENDING_INPROGRESS, STORE_M_PROGRESS, STORE_M_CHOSEN_BRANCH_DATA } from 'src/reducers/mfileupload';

let timeOut: NodeJS.Timer;

export const clearSession = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  if (getState().user.userDetails.s) {

    const userDetails: UserDetail = {
      s: '',
      ugroup: '',
      uroles: '',
      userName: '',
      userGroup: '',
      groupNo: '',
      email: '',
      nickName: '',
      userType: '',
      mobileNumber: '',
      allUserGroup: '',
      responsibilies: '',
      roleName: '',
      labCode: '',
      dmeRequired: '',
    };
    dispatch({ type: STORE_USER_PROFILE, userDetails } as AnyAction);

    const searchType = '';
    dispatch({ type: STORE_SEARCHTYPE, searchType } as AnyAction);
    const searchName = '';
    dispatch({ type: STORE_SEARCHNAME, searchName } as AnyAction);
    const searchValue: SearchValue[] = [];
    dispatch({ type: STORE_SEARCHVALUE, searchValue } as AnyAction);
    const searchTrue = false;
    dispatch({ type: STORE_SEARCHTRUE, searchTrue } as AnyAction);

    const files2: File[] = [];
    dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

    dispatch({ type: STORE_PROGRESS, progress: [] } as AnyAction);

    const previewOrderData = {
      userRxdata: [],
      getUserMessage: [],
      getFileData: [],
      caseNotes: ''
    };
    dispatch({ type: STORE_M_PREVIEWORDER_DATA, previewOrderData } as AnyAction);

    const completeOrderDataDate: RowDataCompleted[] = [];
    dispatch({ type: STORE_COMPLETEORDERDATA_DATE, completeOrderDataDate } as AnyAction);

    const completeOrderData: RowDataCompleted[] = [];
    dispatch({ type: STORE_COMPLETEORDERDATA, completeOrderData } as AnyAction);

    const manucompleteOrderData: RowDataCompleted[] = [];
    dispatch({ type: STORE_MANUFACTCOMPLETEORDERDATA, manucompleteOrderData } as AnyAction);

    const newOrderData: RowDataLive[] = [];
    dispatch({ type: STORE_NEWORDERDATA, newOrderData } as AnyAction);

    const liveOrderData: RowDataLive[] = [];
    dispatch({ type: STORE_LIVEORDERDATA, liveOrderData } as AnyAction);

    const liveOrderDataOnHold: RowDataLive[] = [];
    dispatch({ type: STORE_LIVEORDERDATA_ONHOLD, liveOrderDataOnHold } as AnyAction);

    const liveOrderDataReturned: RowDataLive[] = [];
    dispatch({ type: STORE_LIVEORDERDATA_RETURNED, liveOrderDataReturned } as AnyAction);

    const cancelOrderData: RowDataCancel[] = [];
    dispatch({ type: STORE_CANCELORDERDATA, cancelOrderData } as AnyAction);

    const underDesignData: RowDataManufactur[] = [];
    dispatch({ type: STORE_UNDERDESIGNDATA, underDesignData } as AnyAction);

    const designReadyData: RowDataManufactur[] = [];
    dispatch({ type: STORE_DESIGNREADYDATA, designReadyData } as AnyAction);

    const mHoldOrderData: RowDataManufactur[] = [];
    dispatch({ type: STORE_MHOLDORDERDATA, mHoldOrderData } as AnyAction);

    const mNewOrderData: RowDataManufactur[] = [];
    dispatch({ type: STORE_MNEWORDERDATA, mNewOrderData } as AnyAction);

    const mInproductionOrderData: RowDataManufactur[] = [];
    dispatch({ type: STORE_MINPRODUCTIONORDERDATA, mInproductionOrderData } as AnyAction);

    const mfilteredOrderData: RowDataManufactur[] = [];
    dispatch({ type: STORE_M_FILTERED_DATA, mfilteredOrderData } as AnyAction);

    const mfilterLessOrderData: RowDataManufactur[] = [];
    dispatch({ type: STORE_M_FILTERLESS_DATA, mfilterLessOrderData } as AnyAction);

    const orderrawdata: RowDataRawOrder[] = [];
    dispatch({ type: STORE_ORDERRAWDATA, orderrawdata } as AnyAction);

    const orderrawdataExport: RowDataRawOrder[] = [];
    dispatch({ type: STORE_ORDERRAWDATA_EXPORT, orderrawdataExport } as AnyAction);

    const mfiltersdataExport: RowDataManufactur[] = [];
    dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);

    const completeOrderDataExport: RowDataCompleted[] = [];
    dispatch({ type: STORE_COMPLETEORDERDATA_EXPORT, completeOrderDataExport } as AnyAction);

    const startDateRaw = new Date();
    dispatch({ type: STORE_ORDRAW_STARTDATE, startDateRaw } as AnyAction);
    const endDateRaw = new Date();
    dispatch({ type: STORE_ORDRAW_ENDDATE, endDateRaw } as AnyAction);

    dispatch({ type: STORE_RETURN_TRANSACTION_ID, returnTransactionId: '' } as AnyAction);

    dispatch({ type: STORE_RETURN_TRANSACTION_STATUS, returnTransactionStatus: false } as AnyAction);

    dispatch({ type: STORE_RETURN_TRANSACTION_STATUS_DESC, paymentStatus: '' } as AnyAction);

    dispatch({ type: STORE_PROGRESS_DOWNLOADING, isDownloading: false } as AnyAction);

    dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);

    dispatch({ type: STORE_M_LAB_DATA, mlabData: [] } as AnyAction);

    dispatch({ type: STORE_M_CHOSEN_LAB_DATA, mlabChosen: '0' } as AnyAction);

    dispatch({ type: STORE_M_BRANCH_DATA, mbranchData: [] } as AnyAction);

    dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload: [] } as AnyAction);

    dispatch({ type: STORE_M_SENDING_INPROGRESS, msending: false } as AnyAction);

    dispatch({ type: STORE_M_PROGRESS, mprogress: [] } as AnyAction);

    dispatch({ type: STORE_M_CHOSEN_BRANCH_DATA, mbranchType: '0' } as AnyAction);

    dispatch({ type: STORE_PROGRESS_ISWAITING, isWaiting: false } as AnyAction);

    dispatch({ type: STORE_MYINVOICES_DATA, myInvoicesData: [] } as AnyAction);

    dispatch({ type: STORE_PAIDINVOICE_DATA, getPaidInvoiceData: [] } as AnyAction);

    dispatch({ type: STORE_PAYMENT_DATA, getPaymentData: [] } as AnyAction);

    dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

    dispatch({ type: STORE_VERTICAL_VIEW_SCREEN, verticalViewScreen: false } as AnyAction);

    const userProfiledata = {
      rowno: '',
      custcode: '',
      custname: '',
      emailid: '',
      phoneno: '',
      address1: '',
      address2: '',
      country: '',
      state: '',
      products: '',
      scanners: '',
      contactname: '',
      contactno: '',
      comments: '',
      dsoft: '',
      destination: '',
      tat: '',
      occlusion: '',
      contact: '',
      designtype: '',
      ponticdesign: '',
      modeltype: '',
      notes: ''
    };
    dispatch({ type: STORE_USERPROFILEDATA, userProfiledata } as AnyAction);

    const custname = '';
    const custemail = '';
    const custnumber = '';
    const custaddressone = '';
    const custaddresstwo = '';
    const custcountry = '';
    const custstate = '';
    const custproduct = '';
    const custscanner = '';
    const custcontactName = '';
    const custcontactNumber = '';
    const custcomment = '';
    const custdsoft = '';
    const custdest = '';
    const custtat = '';
    const occlusion = '';
    const designtype = '';
    const ponticdesign = '';
    const contact = '';
    const modeltype = '';
    const notes = '';

    dispatch({ type: STORE_CUSTOMERNAME_PROFILE, custname } as AnyAction);
    dispatch({ type: STORE_CUSTOMEREMAIL_PROFILE, custemail } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPHONENUMBER_PROFILE, custnumber } as AnyAction);
    dispatch({ type: STORE_CUSTOMERADDRESSONE_PROFILE, custaddressone } as AnyAction);
    dispatch({ type: STORE_CUSTOMERADDRESSTWO_PROFILE, custaddresstwo } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCOUNTRY_PROFILE, custcountry } as AnyAction);
    dispatch({ type: STORE_CUSTOMERSTATE_PROFILE, custstate } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPRODUCT_PROFILE, custproduct } as AnyAction);
    dispatch({ type: STORE_CUSTOMERSCANNER_PROFILE, custscanner } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCONTACTNAME_PROFILE, custcontactName } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCONTACTNUMBER_PROFILE, custcontactNumber } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCOMMENT_PROFILE, custcomment } as AnyAction);
    dispatch({ type: STORE_CUSTOMERDSOFT_PROFILE, custdsoft } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCUSTDEST_PROFILE, custdest } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCUSTTAT_PROFILE, custtat } as AnyAction);
    dispatch({ type: STORE_CUSTOMEROCCLUSION, occlusion } as AnyAction);
    dispatch({ type: STORE_CUSTOMERDESIGNTYPE, designtype } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPONTICDESIGN, ponticdesign } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCONTACT, contact } as AnyAction);
    dispatch({ type: STORE_CUSTOMERMODELTYPE, modeltype } as AnyAction);
    dispatch({ type: STORE_CUSTOMERNOTE, notes } as AnyAction);

    const total = '0';
    const completed = '0';
    const onhold = '0';
    const returned = '0';

    dispatch({ type: STORE_DASHBOARD_LIVECOUNT, total } as AnyAction);
    dispatch({ type: STORE_DASHBOARD_COMPLETEDORDER, completed } as AnyAction);
    dispatch({ type: STORE_DASHBOARD_ONHOLD, onhold } as AnyAction);
    dispatch({ type: STORE_DASHBOARD_RETURNED, returned } as AnyAction);

    const items: DataItem[] = [];
    dispatch({ type: STORE_CHART, items } as AnyAction);

    const notificationCount = 0;
    dispatch({ type: STORE_NOTIFICATIONS_COUNT, notificationCount } as AnyAction);

    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    const successBar = false;
    dispatch({ type: STORE_SUCCESS_BAR, successBar } as AnyAction);
    const errorMessage = '';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    const successMessage = '';
    dispatch({ type: STORE_SUCCESS_MESSAGE, successMessage } as AnyAction);

    const successFileUploadOpen: boolean = false;
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);
    const errorFileUploadedOpen: boolean = false;
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    const successfilemsg = '';
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
    const errorfilemsg = '';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

    const startPDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
    const endPDate = new Date();

    dispatch({ type: STORE_P_STARTDATE, startPDate } as AnyAction);
    dispatch({ type: STORE_P_ENDDATE, endPDate } as AnyAction);

    // To be added in future
    // dispatch({ type: STORE_RETURN_TRANSACTION_PAY_U_ID, txnid } as AnyAction);
    // dispatch({ type: STORE_RETURN_TRANSACTION_TXN_AMT, txnamt } as AnyAction);

    return true;
  }
  return true;
};

export const dologoutSession = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  await axios({
    method: 'POST',
    url: `${getState().environment.API_URL
      }logout`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {
    clearSession(dispatch, getState);
    dispatch(push('/login'));
  }).catch(function (error: AxiosError) {
    clearSession(dispatch, getState);
    dispatch(push('/login'));
  });
};

export const doCheckAuthentication = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  if (getState().user.userDetails.s) {
    return true;
  } else {
    dispatch(push('/'));
  }
  return true;
};

export const onSessionOut = (error: AxiosError) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    if (error.response && error.response.status === 403) {

      const errorFileUploadedOpen = true;
      const errorfilemsg = error.response.data.msg;
      dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
      dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

      if (timeOut) {
        clearInterval(timeOut);
      }

      timeOut = setTimeout(() => { dispatch(push('/login')); }, 4000);

    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/aunthenticateAction.ts